import React from 'react';

function Datenschutz() {
  return (
    <section style={{ paddingTop: 'calc(var(--nav-height) + 2rem)' }}>
      <div className="container">
        <h2>Datenschutzerklärung</h2>
        
        <h3>Verantwortlich im Sinne der Datenschutzgesetze, insbesondere der EU-Datenschutzgrundverordnung (DSGVO), ist:</h3>
        <p>
          FH Consulting<br />
          Florian Huber<br />
          Bauernfeindstraße 8<br />
          80939 München<br />
          E-Mail: <a href="mailto:info@fh-consulting.de">info@fh-consulting.de</a><br />
          Telefon: +49 1529 2608956
        </p>
        
        <h3>1. Allgemeine Hinweise</h3>
        <p>
          Der Schutz Ihrer persönlichen Daten ist uns ein besonderes Anliegen. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
        </p>
        
        <h3>2. Zugriffsdaten / Server-Logfiles</h3>
        <p>
          Beim Besuch dieser Website werden durch den Hostinganbieter automatisch Informationen erhoben und in sogenannten Server-Logfiles gespeichert. Diese beinhalten z. B.:
        </p>
        <ul>
          <li>IP-Adresse</li>
          <li>Datum und Uhrzeit der Anfrage</li>
          <li>Browsertyp und Browserversion</li>
          <li>Verwendetes Betriebssystem</li>
          <li>Referrer URL</li>
        </ul>
        <p>
          Diese Daten sind nicht bestimmten Personen zuordenbar und werden nicht mit anderen Datenquellen zusammengeführt.
        </p>
        
        <h3>3. Kontaktformular</h3>
        <p>
          Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Formular inklusive der dort angegebenen Kontaktdaten zur Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
        </p>
        <p>
          <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung und vorvertragliche Maßnahmen)
        </p>
        
        <h3>4. Ihre Rechte</h3>
        <p>Sie haben jederzeit das Recht auf:</p>
        <ul>
          <li>Auskunft über Ihre gespeicherten Daten</li>
          <li>Berichtigung unrichtiger Daten</li>
          <li>Löschung Ihrer Daten</li>
          <li>Einschränkung der Verarbeitung</li>
          <li>Datenübertragbarkeit</li>
          <li>Widerspruch gegen die Verarbeitung</li>
          <li>Beschwerde bei einer Aufsichtsbehörde</li>
        </ul>
        
        <p>
          <strong>Zuständige Aufsichtsbehörde:</strong><br />
          Bayerisches Landesamt für Datenschutzaufsicht (BayLDA)<br />
          Promenade 18, 91522 Ansbach<br />
          <a href="https://www.lda.bayern.de" target="_blank" rel="noopener noreferrer">www.lda.bayern.de</a>
        </p>
        
        <h3>5. SSL-Verschlüsselung</h3>
        <p>
          Diese Website nutzt aus Sicherheitsgründen eine SSL-Verschlüsselung.
        </p>
      </div>
    </section>
  );
}

export default Datenschutz;
